var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23064 0.0509154C5.0434 0.284852 3.03944 1.47521 1.71382 3.32783C1.28612 3.92553 1.15244 4.1543 0.862173 4.7851C0.184964 6.25677 -0.0901235 7.7609 0.0257029 9.35915C0.125925 10.7425 0.456084 11.8259 1.25411 13.3898C1.52635 13.9233 2.25263 15.3461 2.86801 16.5516C3.48344 17.757 4.49719 19.7428 5.12083 20.9644C5.74442 22.186 6.48849 23.6427 6.77431 24.2016C7.06012 24.7604 7.36298 25.3569 7.44739 25.5271C7.68767 26.0116 8.03617 26.1371 8.32198 25.8419C8.76742 25.2865 14.1625 14.6045 15.0674 12.7341C16.1702 10.4547 16.2998 7.86524 15.4303 5.48686C14.6975 3.4824 13.3338 1.88444 11.5205 0.905316C10.6129 0.415262 9.77153 0.16199 8.67847 0.0498119C8.02893 -0.0168447 7.86281 -0.0167283 7.23064 0.0509154ZM8.76658 4.42772C9.86671 4.68018 10.8727 5.4454 11.4328 6.45581C12.0634 7.59327 12.1545 9.2209 11.6546 10.4195C11.1286 11.6806 10.0009 12.6527 8.75987 12.9152C6.05173 13.4879 3.59734 10.9235 4.05544 8.00001C4.3863 5.88854 6.01377 4.3649 7.95456 4.34957C8.20525 4.3476 8.57064 4.38272 8.76658 4.42772Z",
    fill: "#9E9E9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapItem);
export default __webpack_public_path__ + "static/media/mapItem.5abbf6f57755c64e69b4fab7ec6f1640.svg";
export { ForwardRef as ReactComponent };